import Enum from './enum'

/**
 * 公開ステータス
 */
class IsPublished extends Enum {
    static PUBLISHED = 1; // 公開
    static HIDE = 0; // 非公開

    static values() {
        return {
            [this.PUBLISHED]: '公開',
            [this.HIDE]: '非公開',
        }
    }

    static optionsForStudent() {
        return [
            {
                key: this.HIDE,
                label: '下がき',
            },
            {
                key: this.PUBLISHED,
                label: 'かんせい',
            },
        ];
    }

    static optionsForElderStudent() {
        return [
            {
                key: this.HIDE,
                label: '下書き',
            },
            {
                key: this.PUBLISHED,
                label: '完成',
            },
        ];
    }
}

export default IsPublished;
